import React from "react";
import styles from "./HowToUse.module.css";

const HowToUse = () => {
  const steps = [
    {
      number: 1,
      title: "Upload your image",
      description:
        "Drag your image file into the upload area, or browse your files by clicking. Supported formats include JPG, PNG, WEBP.",
      icon: "📤",
    },
    {
      number: 2,
      title: "Change your settings",
      description:
        "Change the compression quality (1 - 100%) and modify the size. Turn off or on the aspect ratio lock if desired, to keep proportions.",
      icon: "⚙️",
    },
    {
      number: 3,
      title: "Download your image",
      description:
        "Check out your compressed image then hit 'Download.' Your new image will save automatically.",
      icon: "💾",
    },
  ];

  return (
    <div className={styles.howToUse}>
      <h2 className={styles.sectionTitle}>Using This Tool</h2>
      <p className={styles.sectionSubtitle}>
        Compress images in just 3 quick steps:
      </p>

      <div className={styles.stepsContainer}>
        {steps.map((step) => (
          <div key={step.number} className={styles.stepCard}>
            <div className={styles.stepHeader}>
              <span className={styles.stepNumber}>Step {step.number}.</span>
              <span className={styles.stepIcon}>{step.icon}</span>
            </div>
            <h3 className={styles.stepTitle}>{step.title}</h3>
            <p className={styles.stepDescription}>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowToUse;
